module.exports = __webpack_public_path__ + "img/sozai.41c35f38.png";